import gql from "graphql-tag";

// Bulk insert of one row rather than `insert_..._one`: the user role can insert but not select this
// table, and Hasura only generates the `_one` field (which returns the row) for roles that can read
// it — same reasoning as InsertUserWelcomeFlowEventMutation.ts.

// One row per platform-review answer — see usePlatformReview.composable.ts's submit(). Production
// only: gated by featureFlags.isDev, so testing on dev never writes an answer row.
// userId/tenantId are stamped by Hasura presets, never sent from the client.
const InsertUserPlatformReviewMutation = gql`
  mutation InsertUserPlatformReview($flowKey: String!, $score: Int!, $comment: String) {
    insert_userPlatformReview(objects: [{ flowKey: $flowKey, score: $score, comment: $comment }]) {
      affected_rows
    }
  }
`;

export default InsertUserPlatformReviewMutation;
